import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Globe } from "lucide-react";
import React, { Dispatch, SetStateAction } from "react";

import useLang from "@/hooks/useLang";
import { countries, CountryType } from "@/constants/data";
import { useAppDispatch } from "@/lib/store/hooks";
import { setLang } from "@/lib/store/features/lang/langSlice";

interface ModalLangProps {
  openModalLang: boolean;
  setOpenModalLang: Dispatch<SetStateAction<boolean>>;
}

const ModalLang = ({ openModalLang, setOpenModalLang }: ModalLangProps) => {
  const { getText } = useLang();
  const dispatch = useAppDispatch();

  const handleSelect = (country: CountryType) => {
    dispatch(setLang(country.code));
    setOpenModalLang(false);
  };
  return (
    <Dialog
      modal
      open={openModalLang}
      onOpenChange={() => setOpenModalLang(false)}
    >
      <DialogContent className="max-w-xs p-3 flex flex-col">
        <DialogHeader className="ps-3">
          <DialogTitle className="flex space-x-2 items-center justify-start text-center font-semibold text-lg">
            <Globe className="stroke-[1.55]" absoluteStrokeWidth />
            <p>{getText({ id: "choose_language" })}</p>
          </DialogTitle>
        </DialogHeader>
        {countries.map((country) => (
          <div
            key={country.code}
            onClick={() => handleSelect(country)}
            className="flex p-3 space-x-2 items-center justify-start cursor-pointer rounded-lg w-full hover:bg-gray-100"
          >
            <span>{country.flag}</span>
            <span>{country.name}</span>
          </div>
        ))}
      </DialogContent>
    </Dialog>
  );
};

export default ModalLang;
